<template>
    <div class="menuandvideo">
        <div class="giftfk" v-if="paycode">
            <div>请用微信扫码支付</div>
            <fkcode :link="rewardpayinfo"></fkcode>
            <br>
            <span style="color: red;">{{ count }}</span> 秒后自动取消
            <br>
            <br>
            <div style="color:#256EE7;" @click="cancelpay()">取消支付</div>
        </div>
        <div class="mb_giftfk" v-if="paycode">
        </div>
        <div class="pro_reward">
            <div @click="excitreward"><img src="../../assets/lives/guan_ds.png" alt="" style="width: 25px;height:25px;"></div>
            <div>
                <div v-if="rewardconfig.rewardQuickEnable" v-for="item in list" @click="price = item">{{item}}元</div>
            </div>
            <div>
                <input type="text" placeholder="请输入打赏金额" style="border-radius: 5px;" v-model="price">
            </div>
            <div @click="createorderbyreward">支付</div>
        </div>
        
    </div>
</template>

<script>
     import fkcode from '../lives/fkcode'
    export default {
  name: 'reward',
  components: {
        fkcode
    },
  props: {
    
  },
  data() {
    return {
        rewardconfig:{},
        list:[],
        paycode:false,
        price:'',
        rewardpayinfo:'',
        count: 60,
        times: null,
        time:null
    }
  },
  mounted() {
    this.getroomconfig()
  },
  methods: {
    excitreward(){
        this.$emit("excitreward",false)
    },
    cancelpay() {
            this.count = 60;
            this.paycode = false
            clearInterval(this.time);
            clearInterval(this.times);
    },
    //获取房间基础设置
    getroomconfig(){
      this.$api.roomconfig().then(res => {
        console.log(res.data.data.rewardQuickEnable);
      this.rewardconfig = res.data.data
      this.list = res.data.data.rewardMoney.split(",")
    }).catch(err=>{
        console.log(err);
      })
    },
    createorderbyreward(){
        if(this.price.length <= 0){
            this.$message({
                message: "请输入打赏金额",
                type: "error"
            });
        }
        else if (Number(this.price).toFixed(2) == '0.00'){
            this.$message({
                message: "打赏金额需大于0",
                type: "error"
            });
        }
        else{
        this.$api.createorderbyreward(Number(this.price).toFixed(2)).then(res=>{
            this.rewardpayinfo = res.data.data.url
            this.paycode = true
            this.times = setInterval(() => {
                this.wxcheckorder(res.data.data.orderNum);
          }, 2000); 
          this.time = setInterval(() => {
                if (this.count <= 0) {
                    clearInterval(this.time);
                    clearInterval(this.times);
                    this.count = 60;
                    this.paycode = false
                    return;
                }
                --this.count;
            }, 1000);
        })
        } 
    },
    wxcheckorder(val) {
            this.$api.wxcheckorder(val).then(res => {
                if (res.data.data.stats == 1) {
                    clearInterval(this.times);
                    clearInterval(this.time)
                    this.paycode = false
                    this.count = 60;
                    this.$message({
                        message: "支付成功",
                        type: "success"
                    });
                    this.$emit("excitreward",false)
                }
            })
        }
  },
 
}
</script>
<style scoped>
.menuandvideo{
    width: 100%;
    height: 100vh;
    position: fixed;
    top: 0;
    background-color: rgba(0, 0, 0, .7);
    z-index: 110;
}
.pro_reward{
    width: 315px;
    height: 380px;
    /* background-color: #fff; */
    background-image: url(../../assets/lives/reward.png);
    background-size: 100%;
    /* background-repeat: no-repeat; */
    position: absolute;
    background-color: #c000;
    top: 25vh;
    left: 39vw;
}
.pro_reward>div:first-child{
    color: #fff;
    font-size: 36px;
    float: right;
    margin-right: 7%;
    margin-top: 3%;
    padding: 5px;
}
.pro_reward>div:nth-child(2){
    display: flex;
    flex-direction: row;
    justify-content: center;
    margin-top: 70%;
}
.pro_reward>div:nth-child(2) div{
    width: 25%;
    height: 30px;
    line-height: 30px;
    background: #FEE287;
    border-radius: 5px; 
    color: #FF7A00;
    font-size: 16px;
    overflow: hidden;
}
.pro_reward>div:nth-child(2) div:nth-child(2){
    margin-left: 15px;
    margin-right: 15px;
}
.pro_reward>div:nth-child(3) input{
    margin-top: 5%;
    outline: none;
    border: 0;
    font-size: 14px;
    width: 60%;
    height: 36px;
    text-align: center;
}
.pro_reward>div:nth-child(4){
    position: absolute;
    text-align: center;
    width: 315px;
    bottom:5%;
    color: #fff;
    font-size: 16px;
    font-weight: 550;
}
.giftfk {
    background-color: #FFFFFF;
    padding: 50px;
    border-radius: 10px;
    height: 240px;
    width: 180px;
    position: fixed;
    z-index: 100;
    top: 30%;
    right: 45%;
  }
  
  .mb_giftfk {
    background-color: #000;
    opacity: 0.6;
    border-radius: 10px;
    position: fixed;
    z-index: 99;
    width: 100vw;
    height: 100vw;
    top: 0;
    right: 0;
  }
</style>
